export const TOGGLE_INSTALLATION_LEGEND_IPHONE = 'TOGGLE_INSTALLATION_LEGEND_IPHONE'

export function displayInstallationLegendIphoneReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_INSTALLATION_LEGEND_IPHONE:
            return action.payload
        default: return state
    }
}